import { inject, ref } from 'vue';
import {
  SW_APPLY_UPDATE_KEY,
  SW_NEED_REFRESH_KEY,
  SW_UPDATE_SERVICE_WORKER_KEY,
} from '../types/service-worker.types';

export function useServiceWorkerUpdate() {
  const needRefresh = inject(SW_NEED_REFRESH_KEY);
  const updateServiceWorker = inject(SW_UPDATE_SERVICE_WORKER_KEY);
  const applyUpdate = inject(SW_APPLY_UPDATE_KEY);

  if (!needRefresh || !updateServiceWorker || !applyUpdate) {
    return {
      needRefresh: ref(false),
      updateServiceWorker: () => Promise.resolve(),
      applyUpdate: () => {},
    };
  }

  return {
    needRefresh,
    updateServiceWorker,
    applyUpdate,
  };
}
